import script from "./ApplicationFileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationFileUpload.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationFileUpload.vue?vue&type=style&index=0&id=79900671&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79900671"]])

export default __exports__